module.exports = __webpack_public_path__ + "static/media/old_old_home_logo.13ed7f32.png";